import { useCreateReservationHoldMutation } from '../store'

export function useCachedCreateReservationHold() {
  const reservationHold = useCreateReservationHoldMutation({
    fixedCacheKey: 'reservation-hold',
  })

  return reservationHold
}
